import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";

// CSS
import "../../styles/newDesign.scss";
import "./Policies.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { resolveTenant } from "../../Helper/Api";

// Content
import { CONTENT, LAST_UPDATED } from "./policiesContent";

// Properties
const properties = require("../../properties.json");

const LANG_KEY = "manasa_policies_lang";

// Starting language: ?lang=ar|en wins (the desktop app passes its own UI language that way),
// then the visitor's last choice on this page, then English like the rest of the site.
function initialLang() {
  const fromQuery = new URLSearchParams(window.location.search).get("lang");
  if (fromQuery === "ar" || fromQuery === "en") return fromQuery;
  try {
    const saved = window.localStorage.getItem(LANG_KEY);
    if (saved === "ar" || saved === "en") return saved;
  } catch (e) {
    // Storage blocked (private mode etc.) -- fall through to the default.
  }
  return "en";
}

/** Privacy Policy (/privacy) and Terms of Use (/terms) -- one page, `doc` picks which. Static text
 *  shared by every teacher domain (see policiesContent.js), with the teacher's name filled in. */
class Policies extends Component {
  state = {
    tenant: null,
    notFound: false,
    lang: initialLang(),
  };

  componentDidMount() {
    resolveTenant()
      .then((tenant) => {
        this.setState({ tenant }, this.updateTitle);
      })
      .catch(() => this.setState({ notFound: true }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.doc !== this.props.doc || prevState.lang !== this.state.lang) {
      this.updateTitle();
    }
  }

  updateTitle = () => {
    const { tenant, lang } = this.state;
    const title = CONTENT[lang][this.props.doc].title;
    document.title = tenant && tenant.name ? `${title} | ${tenant.name}` : properties.site_name;
  };

  setLang = (lang) => {
    try {
      window.localStorage.setItem(LANG_KEY, lang);
    } catch (e) {
      // Not persisted -- the switch still applies for this visit.
    }
    this.setState({ lang });
  };

  render() {
    const { tenant, notFound, lang } = this.state;
    const { doc } = this.props;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }

    if (!tenant) return null;

    const name = tenant.name || "";
    const fill = (text) => text.split("{name}").join(name);
    const content = CONTENT[lang][doc];
    const isAr = lang === "ar";
    const query = `?lang=${lang}`;

    return (
      <>
        <Header tenant={tenant} />

        <div className={`nd-page policies-page ${isAr ? "is-ar" : ""}`} dir={isAr ? "rtl" : "ltr"} lang={lang}>
          <div className="nd-hero">
            <div className="nd-wrap">
              <div className="policies-top">
                <div className="policies-tabs" role="tablist">
                  <NavLink to={`/privacy${query}`} isActive={() => doc === "privacy"}>
                    {CONTENT[lang].privacy.title}
                  </NavLink>
                  <NavLink to={`/terms${query}`} isActive={() => doc === "terms"}>
                    {CONTENT[lang].terms.title}
                  </NavLink>
                </div>
                <button
                  type="button"
                  className="policies-lang"
                  onClick={() => this.setLang(isAr ? "en" : "ar")}
                >
                  {isAr ? "English" : "العربية"}
                </button>
              </div>
              <h1>{content.title}</h1>
              <div className="policies-updated">
                {isAr ? "آخر تحديث: " : "Last updated: "}
                {LAST_UPDATED}
              </div>
              <p>{fill(content.intro)}</p>
            </div>
          </div>

          {/* Separate elements on purpose: .nd-section's "padding: 64px 0" would otherwise override
              .nd-wrap's side padding (same specificity, declared later), gluing text to the edge. */}
          <div className="nd-section">
            <div className="nd-wrap">
              <div className="policies-body">
                {content.sections.map((section) => (
                  <section key={section.heading}>
                    <h3>{section.heading}</h3>
                    <ul>
                      {section.items.map((item, i) => (
                        <li key={i}>{fill(item)}</li>
                      ))}
                    </ul>
                  </section>
                ))}

                <div className="policies-contact">
                  <Link to="/contact" className="nd-btn-dark">
                    {isAr ? "صفحة التواصل" : "Contact page"}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default Policies;
